<template>
  <div style="width:100%;">
    <span v-if="selected">
      <slot v-bind:item="selected" name="selection">{{ selected.name }}</slot>
    </span>
    <v-btn :disabled="disabled" @click="openModal" small>{{
      buttonText
    }}</v-btn>
    <v-btn v-if="showClearButton" @click="clearItem" fab small>
      <v-icon>clear</v-icon>
    </v-btn>
    <slot name="append" />
    <v-dialog v-model="isShowingModal" :max-width="maxWidth">
      <v-card>
        <v-card-title>
          <h3>{{ modalTitle }}</h3>
        </v-card-title>
        <v-card-text style="height:60vh;">
          <v-layout wrap>
            <v-flex xs11>
              <v-text-field
                ref="searchKeywordField"
                v-model="searchKeyword"
                :disabled="loading"
                :rules="searchRules"
                @keydown.enter="emitSearch"
                placeholder="検索キーワードを入力してください。"
                solo
              />
            </v-flex>
            <v-flex xs1>
              <v-btn
                :loading="loading"
                :color="canSearch ? 'primary' : 'grey'"
                :class="{ 'disable-button': !canSearch }"
                @click="emitSearch"
                fab
                dark
                small
                depressed
              >
                <v-icon dark>mdi-magnify</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-slide-y-transition>
                <v-list
                  v-if="searchedList.length > 0"
                  class="scroll-y brand-list"
                >
                  <v-list-tile
                    v-for="(item, index) in searchedList"
                    :key="index"
                    :class="{ 'selected-item': index === selectedIndex }"
                    @click="selectItem(item, index)"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <slot v-bind:item="item" name="item">
                          {{ item.name }}
                        </slot>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-slide-y-transition>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="isShowingModal = false" color="primary"
            >閉じる</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    canNotSearchWhenBlankKeyword: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '検索',
    },
    modalTitle: {
      type: String,
      default: '検索',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    showListOnInit: {
      type: Boolean,
      default: false,
    },
    showListOnInitSearchKeyword: {
      type: String,
      default: '',
    },
    searchedList: {
      type: Array,
      default: () => [],
    },
    selectedItemName: {
      type: String,
      default: '',
    },
    selectedItem: {
      type: Object,
      default: null,
    },
    maxWidth: {
      type: String,
      default: '70vw',
      // edit-modalより10vw狭い
    },
  },
  data() {
    return {
      searchKeyword: '',
      isShowingModal: false,
      selectedIndex: undefined,
      selected: null,
    }
  },
  computed: {
    selectedId: {
      get() {
        return this.value
      },
      set(id) {
        this.$emit('input', id)
      },
    },
    showClearButton() {
      return this.clearable && this.selectedItemName.length > 0
    },
    canSearch() {
      if (!this.canNotSearchWhenBlankKeyword) {
        return true
      }
      return this.searchKeyword !== ''
    },
    searchRules() {
      if (!this.canSearch) {
        return ['検索キーワードを入力してください']
      }
      return []
    },
  },
  watch: {
    isShowingModal(newVal) {
      this.searchKeyword = ''
      // 初回サーチを実行する場合、初期用キーワード（初期値カラ）で検索
      if (newVal && this.showListOnInit) {
        this.searchKeyword = this.showListOnInitSearchKeyword
        this.emitSearch()
        this.$emit('clearList')
      }
    },
    selectedItem() {
      this.selected = this.selectedItem
    },
  },
  methods: {
    selectItem(item, index) {
      this.selectedIndex = index
      this.selected = item
      this.$emit('change', item)
    },
    clearItem() {
      this.selectItem({ id: undefined, name: undefined }, undefined)
    },
    openModal() {
      this.isShowingModal = true
      this.$nextTick(() => this.$refs.searchKeywordField.focus())
    },
    emitSearch() {
      this.$emit('search', this.searchKeyword)
    },
  },
}
</script>

<style scoped>
.brand-list {
  max-height: 48vh;
  width: 88%;
  border: 1px solid #ddd;
}
.selected-item {
  background-color: #e0f7fa;
  color: white;
}
.disable-button {
  pointer-events: none;
}
</style>
